import cn from 'classnames'
import React, {
  ComponentProps,
  MutableRefObject,
  ReactElement,
  useEffect,
  useRef,
} from 'react'
import SvgCollapse from 'src/components/Svgs/SvgCollapse'
import SvgCheck from 'src/components/Svgs/SvgNewCheck'

import style from './Checkbox.style'

export type CheckboxProps = ComponentProps<'input'> & {
  checked?: boolean
  isInvalid?: boolean
  isPartial?: boolean
}

function Checkbox(props: CheckboxProps): ReactElement {
  const {
    className = '',
    isInvalid = false,
    isPartial = false,
    ...rest
  } = props

  const inputRef: MutableRefObject<HTMLInputElement | null> = useRef(null)

  useEffect(() => {
    // Set css :invalid
    if (isInvalid) {
      inputRef.current?.setCustomValidity('Your input is invalid.')
    } else {
      inputRef.current?.setCustomValidity('')
    }
  }, [isInvalid])

  return (
    <div className={cn('Checkbox', className)} css={style}>
      <input
        className={cn(isPartial && 'partial')}
        type="checkbox"
        ref={inputRef}
        {...rest}
      />
      {isPartial ? (
        <SvgCollapse viewBox="0.5 0.5 24 24" stroke="white" fill="white" />
      ) : (
        <SvgCheck viewBox="-4 -4 24 24" stroke="white" strokeWidth="2" />
      )}
    </div>
  )
}

export default Checkbox
